import React, { Component } from 'react';
import { RACE_INFO_SERVICE } from 'configs/rest';
import icon from './downloadpdf.svg';

import getTexts from 'utils/localization';
import {
    DownloadButton,
    DownloadButtonIcon,
    DownloadButtonLabel,
} from 'features/PdfDownload/styled';
const t = getTexts();

class IframePdf extends Component {
    constructor() {
        super();

        this.state = {
            iframeCode: '',
        };
    }

    downloadPdf = () => {
        let { trackId, date } = this.props.getSelectedDayData(
            this.props.AISDataProvider
        );

        if (trackId && date) {
            let linkToFile = RACE_INFO_SERVICE(trackId, date);

            this.setState(
                {
                    iframeCode: (
                        <iframe
                            title="pdf-download"
                            style={{
                                display: 'none',
                                height: 0,
                                width: 0,
                            }}
                            src={linkToFile}
                        />
                    ),
                },
                () => {
                    /* remove iframe after pdf was downloaded */
                    setTimeout(() => {
                        this.setState({ iframeCode: '' });
                    }, 2000);
                }
            );
        } else {
            console.log('raceDay is null');
        }
    };

    render() {
        return (
            <div>
                <DownloadButton onClick={this.downloadPdf}>
                    <DownloadButtonLabel>
                        {t.PdfDownload.courseProgram}
                    </DownloadButtonLabel>
                    <DownloadButtonIcon>
                        <img src={icon} alt="Download PDF" />
                    </DownloadButtonIcon>
                </DownloadButton>
                {this.state.iframeCode}
            </div>
        );
    }
}

export default IframePdf;
